export default __webpack_public_path__ + "static/media/acne-scar.2c6ae4c3.JPG";